import { Injectable, signal } from "@angular/core";
import { ApiService } from "app/core/http/api.service";
import { buildHttpOptions } from "app/core/http/BuildHttpOptions";
import { map, Observable } from "rxjs";
import { VehicleStockData } from "../mandat-dashboard/mandat-dashboard.service";
import { TradeInVehicle, UpcomingVehicle } from "./purchase-dashboard.component";
import { ListParams } from "app/shared/models/listParams";
import { PaginationResult } from "app/shared/models/pagination";

export interface PurchaseAdminDashboardSummaryResponse {
    vehicleStock: VehicleStockData;
}
export interface UpcomingVehicleDto {
    fullName: string;
    internNumber: string;
    estimatedArrival: string; // ISO string from backend, convert to Date if needed
    vehicleId: string;
}
export interface TradeInDto {
    fullName: string;
    internNumber: string;
    vehicleStatus: string;
    contractId: string;
}

@Injectable({ providedIn: 'root' })
export class PurchaseAdminDashboardService {
    private _upcomingVehiclesParams = signal<ListParams>({
        searchText: '',
        sortField: '',
        sortDirection: '',
        pagination: {
            currentPage: 0,
            itemsPerPage: 10,
            totalItems: 0,
            totalPages: 0
        },
        mandatId: ""
    });

    private _tradeInsParams = signal<ListParams>({
        searchText: '',
        sortField: '',
        sortDirection: '',
        pagination: {
            currentPage: 0,
            itemsPerPage: 10,
            totalItems: 0,
            totalPages: 0
        },
        mandatId: ""
    });


    get upcomingVehiclesParams() {
        return this._upcomingVehiclesParams;
    }
    get tradeInsParams() {
        return this._tradeInsParams;
    }

    dashboardUrl = '/dashboard/purchase/';
    constructor(private api: ApiService) { }

    getPurchaseAdminDashboardData(VehicleStockPeriod: string): Observable<PurchaseAdminDashboardSummaryResponse> {

        const options = buildHttpOptions({
            extraParams: { vehicleStockPeriod: VehicleStockPeriod }
        });

        return this.api.get<PurchaseAdminDashboardSummaryResponse>(this.dashboardUrl + "summary", options);
    }

    getUpcomingVehicles(): Observable<PaginationResult<UpcomingVehicleDto[]>> {
        const options = buildHttpOptions({
            searchText: this._upcomingVehiclesParams().searchText,
            page: this._upcomingVehiclesParams().pagination.currentPage,
            itemsPerPage: this._upcomingVehiclesParams().pagination.itemsPerPage,
            sortField: this._upcomingVehiclesParams().sortField,
            sortDirection: this._upcomingVehiclesParams().sortDirection
        });

        const paginationResult: PaginationResult<UpcomingVehicleDto[]> = new PaginationResult<UpcomingVehicleDto[]>();

        return this.api.getList<UpcomingVehicleDto[]>(this.dashboardUrl + 'get-upcoming-vehicles', options)
            .pipe(
                map((response) => {
                    console.log(response);
                    paginationResult.result = response.body!;
                    if (response.headers.get('Pagination') != null) {
                        paginationResult.pagination = JSON.parse(response.headers.get('Pagination')!)
                    }
                    return paginationResult;
                })
            )
    }

    getTradeInsVehicles(): Observable<PaginationResult<TradeInDto[]>> {
        const options = buildHttpOptions({
            searchText: this._tradeInsParams().searchText,
            page: this._tradeInsParams().pagination.currentPage,
            itemsPerPage: this._tradeInsParams().pagination.itemsPerPage,
            sortField: this._tradeInsParams().sortField,
            sortDirection: this._tradeInsParams().sortDirection
        });

        const paginationResult: PaginationResult<TradeInDto[]> = new PaginationResult<TradeInDto[]>();

        return this.api.getList<TradeInDto[]>(this.dashboardUrl + 'get-tradeins-vehicles', options)
            .pipe(
                map((response) => {
                    paginationResult.result = response.body!;
                    if (response.headers.get('Pagination') != null) {
                        paginationResult.pagination = JSON.parse(response.headers.get('Pagination')!)
                    }
                    return paginationResult;
                })
            )
    }
}

export const UPCOMING_VEHICLES_MOCK: UpcomingVehicle[] = [
    {
        model: 'BMW 320i',
        internNumber: '432423423432432',
        eta: new Date('2025-08-12'),
    },
    {
        model: 'Audi A4 Avant',
        internNumber: '432423423432432',
        eta: new Date('2025-08-18'),
    },
    {
        model: 'Tesla Model Y',
        internNumber: '432423423432432',
        eta: new Date('2025-09-02')
    },
    {
        model: 'Volkswagen Golf',
        internNumber: '432423423432432',
        eta: new Date('2025-08-25'),
    }
];

export const TRADE_IN_VEHICLES_MOCK: TradeInVehicle[] = [
    {
        vinNumber: 'WBA3A5C52DF123456',
        model: 'BMW 320i Touring',
        status: 'Pending Evaluation',
        contractId: 'C-2024-001'
    },
    {
        vinNumber: 'WAUZZZ8K4EA098765',
        model: 'Audi A4 Avant',
        status: 'Accepted',
        contractId: 'C-2024-002'
    },
    {
        vinNumber: 'WVWZZZ1KZAW123456',
        model: 'Volkswagen Golf 1.6 TDI',
        status: 'Rejected',
        contractId: 'C-2024-003'
    },
    {
        vinNumber: 'VF3CC5FS0DT987654',
        model: 'Peugeot 308 SW',
        status: 'Completed',
        contractId: 'C-2024-004'
    },
    {
        vinNumber: '5YJSA1DP9DFP98765',
        model: 'Tesla Model S',
        status: 'Pending Evaluation',
        contractId: 'C-2024-005'
    }
];
